import isFunction from './isFunction';
export default function isEmpty(subject) {
    if (subject['length'] === 0) {
        return true;
    }
    if (isFunction(subject['length']) && subject['length']() === 0) {
        return true;
    }
    if (subject['count'] === 0) {
        return true;
    }
    if (isFunction(subject['count']) && subject['count']() === 0) {
        return true;
    }
    return false;
}
